import { render, staticRenderFns } from "./VSelectField.vue?vue&type=template&id=83fcb6a2"
import script from "./VSelectField.vue?vue&type=script&lang=js"
export * from "./VSelectField.vue?vue&type=script&lang=js"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VSelectField.vue?vue&type=style&index=1&id=83fcb6a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports